/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Documents_In_The_Vault_YetInputs */

const en_no_documents_in_the_vault_yet = /** @type {(inputs: No_Documents_In_The_Vault_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No documents in the vault yet.`)
};

const es_no_documents_in_the_vault_yet = /** @type {(inputs: No_Documents_In_The_Vault_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay documentos en la bóveda.`)
};

const fr_no_documents_in_the_vault_yet = /** @type {(inputs: No_Documents_In_The_Vault_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun document dans le coffre-fort pour le moment.`)
};

const de_no_documents_in_the_vault_yet = /** @type {(inputs: No_Documents_In_The_Vault_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Dokumente im Vault.`)
};

const ja_no_documents_in_the_vault_yet = /** @type {(inputs: No_Documents_In_The_Vault_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保管庫にはまだドキュメントがありません。`)
};

const zh_no_documents_in_the_vault_yet = /** @type {(inputs: No_Documents_In_The_Vault_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`金库中暂无文档。`)
};

const ar_no_documents_in_the_vault_yet = /** @type {(inputs: No_Documents_In_The_Vault_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد مستندات في الخزنة بعد.`)
};

const id_no_documents_in_the_vault_yet = /** @type {(inputs: No_Documents_In_The_Vault_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada dokumen di dalam Vault.`)
};

const it_no_documents_in_the_vault_yet = /** @type {(inputs: No_Documents_In_The_Vault_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessun documento nel vault.`)
};

const ru_no_documents_in_the_vault_yet = /** @type {(inputs: No_Documents_In_The_Vault_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В хранилище пока нет документов.`)
};

const pt_no_documents_in_the_vault_yet = /** @type {(inputs: No_Documents_In_The_Vault_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum documento no cofre ainda.`)
};

const ko_no_documents_in_the_vault_yet = /** @type {(inputs: No_Documents_In_The_Vault_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`보관소에 아직 문서가 없습니다.`)
};

/**
* | output |
* | --- |
* | "No documents in the vault yet." |
*
* @param {No_Documents_In_The_Vault_YetInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const no_documents_in_the_vault_yet = /** @type {((inputs?: No_Documents_In_The_Vault_YetInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Documents_In_The_Vault_YetInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_documents_in_the_vault_yet(inputs)
	if (locale === "es") return es_no_documents_in_the_vault_yet(inputs)
	if (locale === "fr") return fr_no_documents_in_the_vault_yet(inputs)
	if (locale === "de") return de_no_documents_in_the_vault_yet(inputs)
	if (locale === "ja") return ja_no_documents_in_the_vault_yet(inputs)
	if (locale === "zh") return zh_no_documents_in_the_vault_yet(inputs)
	if (locale === "ar") return ar_no_documents_in_the_vault_yet(inputs)
	if (locale === "id") return id_no_documents_in_the_vault_yet(inputs)
	if (locale === "it") return it_no_documents_in_the_vault_yet(inputs)
	if (locale === "ru") return ru_no_documents_in_the_vault_yet(inputs)
	if (locale === "pt") return pt_no_documents_in_the_vault_yet(inputs)
	return ko_no_documents_in_the_vault_yet(inputs)
});